/* global waitForElm */
(() => {
	const $ = {
		root: '.header__account',
		toggle: '[data-js-header-account-toggle]',
		wrapper: '[data-js-header-account-content]',
		myAccountPage: '.myaccount-page',
		close: '[data-js-header-account-close]',
	};

	let accountOpen = false;

	const checkPageAccount = () => {
		if (
			bsBreakpoints.detectBreakpoint() === 'xLarge' ||
			bsBreakpoints.detectBreakpoint() === 'large'
		) {
			const page = document.querySelector($.myAccountPage);

			if (page) {
				accountOpen = true;
				document.querySelector($.toggle).disabled = true;
			}
		}

		return accountOpen;
	};

	const linkActive = () => {
		if (accountOpen) {
			const pathName = window.location.href;

			document
				.querySelectorAll('.header__account__list__item a')
				.forEach((link) => {
					console.log(pathName);
					if (link.href === pathName) {
						link.classList.add('active');
					}
				});
		}
	};

	const activeAccount = () => {
		if (accountOpen) {
			document.querySelector($.root).classList.add('active');
		} else {
			if (document.querySelector($.root).classList.contains('active')) {
				document.querySelector($.root).classList.remove('active');
			}
		}
	};

	const pageAccountComportement = (bloc) => {
		if (
			bsBreakpoints.detectBreakpoint() === 'xLarge' ||
			bsBreakpoints.detectBreakpoint() === 'large'
		) {
			if (document.querySelector($.myAccountPage)) {
				if (document.querySelector($.wrapper)) {
					const blocAccount = document.querySelector($.wrapper);
					const blocAccountWidth = blocAccount.offsetWidth;
					const marginRightPage = parseFloat(
						window.getComputedStyle(document.querySelector('main'))
							.marginRight
					);
					if (
						!document
							.querySelector($.wrapper)
							.classList.contains('permanently')
					) {
						document
							.querySelector($.wrapper)
							.classList.add('permanently');
					}

					let blocMaxWidth =
						document.querySelector('html').clientWidth -
						(blocAccountWidth + marginRightPage) -
						46;
					bloc.style.maxWidth = blocMaxWidth + 'px';
				}
			}
		}

		if (
			bsBreakpoints.detectBreakpoint() === 'medium' ||
			bsBreakpoints.detectBreakpoint() === 'xSmall'
		) {
			if (bloc) {
				if (bloc.hasAttribute('style')) {
					bloc.removeAttribute('style');
				}
			}
			const wrapper = document.querySelector($.wrapper) || null;
			if (wrapper && wrapper.classList.contains('permanently')) {
				wrapper.classList.remove('permanently');
			}
		}
	};

	const clickButtonAccount = () => {
		if (document.querySelector($.toggle)) {
			document.querySelector($.toggle).addEventListener('click', () => {
				if (!accountOpen) {
					accountOpen = true;
				} else {
					accountOpen = false;
				}

				activeAccount();
			});
		}
		if (document.querySelector($.close)) {
			document.querySelector($.close).addEventListener('click', () => {
				accountOpen = false;

				activeAccount();
			});
		}

		window.addEventListener('click', (e) => {
			if (accountOpen && !document.querySelector($.myAccountPage)) {
				if (!document.querySelector($.root).contains(e.target)) {
					accountOpen = false;

					activeAccount();
				}
			}
		});
	};

	const init = () => {
		waitForElm('[data-header-account]').then((root) => {
			if (root) {
				checkPageAccount();
				activeAccount();
				pageAccountComportement(
					document.querySelector($.myAccountPage)
				);

				if (document.querySelector('.breadcrumbs-block')) {
					pageAccountComportement(
						document.querySelector('.breadcrumbs-block')
					);
				}

				clickButtonAccount();
				linkActive();

				window.addEventListener('resize', () => {
					if (root) {
						checkPageAccount();
						activeAccount();
						pageAccountComportement(
							document.querySelector($.myAccountPage)
						);

						if (document.querySelector('.breadcrumbs-block')) {
							pageAccountComportement(
								document.querySelector('.breadcrumbs-block')
							);
						}
					}
				});
			}
		});
	};

	init();
})();
